import axios from 'axios'
import { SOCKET_API_URL } from '../../env/env'

/**
 *
 * @param {object} payload invite candidate payload
 * @returns
 */
export const inviteCandidate = async (payload) => {
  const response = await axios.post('candidates/invite', payload)
  return response
}

export const uploadCandidateResumeFromProfile = async (payload) => {
  const response = await axios.put('candidates/resume', payload)
  return response
}

/**
 *
 * @param {string} token hash for verifying user
 * @returns
 */
export const verifyInvitedCandidate = async (token, contestUri) => {
  const response = await axios.post(
    `candidate-tokens/${token}?contestUri=${contestUri}`
  )
  return response
}

/**
 * API for setting password for invited candidate
 * @param {String} token candidate Token
 * @param {String} hashToken candidate Hash Token
 * @param {String} password candidate Password
 * @returns
 */
export const setCandidatePassword = async (
  token,
  hashToken,
  password,
  contestUri
) => {
  const response = await axios.post(
    'candidates/set-password',
    { password, token: hashToken },
    { headers: { Authorization: `Bearer ${token}` } }
  )
  return response
}

/**
 *
 * @param {object} payload
 * @param {string} contestUri
 * @returns
 */
export const loginCandidate = async (
  payload,
  contestUri = null,
  forced = false
) => {
  const response = await axios.post(
    `candidates/login?${
      contestUri
        ? `contestUri=${contestUri}&forced=${forced}`
        : `forced=${forced}`
    }`,
    payload
  )
  return response
}

/**
 *
 * @param {object} payload
 * @param {string} contestUri
 * @returns
 */
export const signupCandidate = async (payload, contestUri = null) => {
  const response = await axios.post(
    `candidates/signup${contestUri ? `?contestUri=${contestUri}` : ``}`,
    payload
  )
  return response
}

/**
 *
 * @param {string} token hash for verifying user
 * @returns
 */
export const verifyCandidate = async (token, contestUri = null) => {
  const response = await axios.post(
    `candidate-tokens/verify/${token}${
      contestUri ? `?contestUri=${contestUri}` : ''
    }`
  )
  return response
}

/**
 *
 * @param {String} token user hash token
 * @param {String} contestUri user hash token
 * @returns
 */
export const resendCandidateVerificationLink = async (
  token,
  contestUri = null
) => {
  const response = await axios.post(
    `candidate-tokens/resend/${token}${
      contestUri ? `?contestUri=${contestUri}` : ''
    }`,
    null
  )
  return response
}

/**
 *
 * @param {string} contestUri
 * @returns return contest details with active stages
 */
export const getContestDetails = async (contestUri) => {
  const response = await axios.get(`contests/${contestUri}/stages`)
  return response
}

/**
 *
 * @param {string} contestUri
 * @param {string} stageId
 * @param {string} attemptId
 * @param {string} demoChallengeId
 * @returns
 */
export const getStageAttemptDetails = async (
  stageId,
  attemptId,
  contestUri,
  demoChallengeId
) => {
  const payload = {
    ...(stageId ? { stageId } : {}),
    ...(attemptId ? { attemptId } : {}),
    ...(contestUri ? { contestUri } : {}),
    ...(demoChallengeId ? { demoChallengeId } : {})
  }

  let inputString = ''

  Object.keys(payload).forEach((key, index) => {
    inputString +=
      index === 0 ? `${key}=${payload[key]}` : `&${key}=${payload[key]}`
  })

  const response = await axios.get(`candidate-attempts?${inputString}`)
  return response
}

/**
 *
 * @param {string} attemptId
 * @returns
 */
export const updateStageStatus = async (attemptId) => {
  const response = await axios.put(
    `candidate-attempts/${attemptId}/status?status=IN_PROGRESS`
  )
  return response
}

/**
 *
 * @param {object} payload
 * @returns
 */
export const addDurationForCandidateAttempt = async (payload) => {
  const response = await axios.put('candidate-attempts', payload)
  return response
}

/**
 *
 * @param {Object} payload
 * @returns
 */
export const setCandidateTopicPreference = async (payload) => {
  const response = await axios.post(
    'candidate-answers/topic-preference',
    payload
  )
  return response
}

export const setCandidateLanguagePreference = async (payload) => {
  const response = await axios.post(
    'candidate-attempts/language-preference',
    payload
  )
  return response
}

/**
 *
 * @param {string} attemptId
 * @param {string} learningProgressId
 * @returns
 */
export const getCandidateMCQAttempts = async (
  attemptId,
  learningProgressId
) => {
  const query = {
    ...(attemptId ? { attemptId } : {}),
    ...(learningProgressId ? { learningProgressId } : {})
  }

  const queryString = new URLSearchParams(query).toString()

  const response = await axios.get(
    `candidate-answers${queryString ? `?${queryString}` : ''}`
  )

  return response
}

/**
 *
 * @param {Object} payload
 * @returns
 */
export const setCandidateSelectedOptions = async (payload) => {
  const response = await axios.post('candidate-answers', payload)
  return response
}

/**
 *
 * @param {Object} payload
 * @returns
 */
export const setCandidateQuestionFlag = async (payload) => {
  const response = await axios.post('candidate-answers/flags', payload)
  return response
}

/**
 *
 * @param {string} attemptId
 * @param {string} learningProgressId
 * @returns
 */
export const submitCandidateMCQChallenge = async (
  attemptId = null,
  learningProgressId = null
) => {
  const query = {
    ...(attemptId ? { attemptId } : {}),
    ...(learningProgressId ? { learningProgressId } : {})
  }

  const queryString = new URLSearchParams(query).toString()

  const response = await axios.post(
    `attempt-results/mcq${queryString ? `?${queryString}` : ''}`
  )
  return response
}

/**
 *
 * @param {string} contestId
 * @returns
 */
export const getCandidateScheduleDetails = async (contestId) => {
  const response = await axios.get(
    `candidate-schedules/details?contestId=${contestId}`
  )
  return response
}
/**
 *
 * @param {string} contestId
 * @returns pending evaluating stages for contest
 */

export const getPendingManualEvaluationStagesDetails = async (contestId) => {
  const response = await axios.get(
    `candidate-attempts/stage-manual-evaluations?contestId=${contestId}`
  )
  return response
}

/**
 *
 * @param {string} stageId
 * @returns pending evaluation attempt at stage level
 */
export const getPendingManualEvaluationAttemptDetails = async (stageId) => {
  const response = await axios.get(
    `candidate-attempts/manual-evaluation-attempts?contestStageId=${stageId}`
  )
  return response
}

/**
 *
 * @param {object} payload {score,attemptId}
 * @returns
 */
export const assignScoreForManualEvaluation = async (payload) => {
  const { isUpdate = false, ...rest } = payload
  const response = isUpdate
    ? await axios.put(`attempt-results/manual-evaluation`, rest)
    : await axios.post(`attempt-results/manual-evaluation`, rest)
  return response
}

/**
 *
 * @param {Object} payload
 * @returns
 */
export const candidateAttemptEvents = async (payload) => {
  const response = await axios.post(`candidate-attempt-events`, payload)
  return response
}

/**
 *
 * @param {Object} payload
 * @returns
 */
export const candidateAttemptEventsWithImage = async (
  attemptId,
  event,
  formData
) => {
  const response = await axios.post(
    `candidate-attempt-events/image?attemptId=${attemptId}&event=${event}`,
    formData,
    {
      headers: { 'content-type': 'multipart/form-data' }
    }
  )
  return response
}

/**
 *
 * @returns profile details for candidate
 */
export const getCandidateProfile = async () => {
  const response = await axios.get(`candidates/profile`)
  return response
}

/**
 *
 * @param {object} payload
 * @returns
 */
export const uploadCandidateProfileDetails = async (payload) => {
  const response = await axios.put(`candidates/update-profile`, payload)
  return response
}

/**
 *
 * @param {object} payload
 * @returns
 */
export const uploadCandidateProfilePicture = async (payload) => {
  const response = await axios.post(`candidates/profile-pic`, payload, {
    headers: { 'content-type': 'multipart/form-data' }
  })
  return response
}

/**
 *
 * @param {object} payload
 * @returns
 */
export const changePasswordForCandidate = async (payload) => {
  const response = await axios.put(`candidates/change-password`, payload)
  return response
}

/**
 *
 * @returns list of candidate's contest
 */
export const getCandidateContestList = async () => {
  const response = await axios.get(`candidates/contest-list`)
  return response
}

/**
 *
 * @param {string} contestId
 * @returns update candidate invite status
 */
export const verifyContestInvite = async (contestId) => {
  const response = await axios.post(
    `candidates/verify-contest${contestId ? `?contestId=${contestId}` : ''}`
  )
  return response
}

export const getCandidateRegistrationForm = async (
  contestUri,
  usedAfterInviting
) => {
  const response = usedAfterInviting
    ? await axios.get(`contest-forms/${contestUri}/register-form`)
    : await axios.get(`contest-forms/register`, { params: { contestUri } })

  return response
}

export const submitCandidateRegistration = async (
  contestUri,
  formData,
  usedAfterInviting = false
) => {
  const url = !usedAfterInviting
    ? `contest-forms/submit`
    : `contest-forms/candidate/submit`

  const params = { contestUri }

  return axios.post(url, formData, { params })
}

/**
 *
 * @param {string} contestId
 * @param {string} email
 * @param {string} fieldId
 * @returns
 */
export const downloadRegistrationFile = async (contestId, email, fieldId) => {
  const response = await axios.get(
    `contest-forms/${contestId || null}/export`,
    { responseType: 'blob', params: { email, fieldId } }
  )

  return response
}

/**
 *
 * @param {string} email
 * @param {string} contestId
 */
export const getCandidateRegistrationDetails = async (email, contestId) => {
  const response = await axios.get(`contest-forms/candidate`, {
    params: { email, contestId }
  })

  return response
}

/**
 *
 * @param {string} contestId
 * @param {string} type
 * @returns
 */
export const sendReminderEmail = async (payload) => {
  const response = await axios.post(`candidates/send-email-reminder`, payload)
  return response
}

/**
 *
 * @param {string} contestId
 * @param {string} type
 * @returns
 */
export const previewReminderEmail = async (contestId, type) => {
  const response = await axios.get(`emails/preview-email`, {
    params: { contestId, type }
  })
  return response
}

/**
 *
 * @param {string} contestId
 * @param {array of string} emails
 * @returns
 */
export const preInviteCandidate = async (
  contestId,
  emails,
  startTime = null
) => {
  const response = await axios.post(`contests/pre-invite`, {
    contestId,
    candidateEmails: emails,
    startTime
  })
  return response
}

/**
 *
 * @param {string} contestId
 * @param {string} email
 * @returns
 */
export const forceInviteCandidate = async (
  contestId,
  email,
  startTime = null
) => {
  const response = await axios.post(`contests/force-invite`, {
    contestId,
    email,
    startTime
  })
  return response
}

/**
 *
 * @param {string} contestId
 * @param {boolean} isRegistered
 * @param {boolean} hasResumeStage
 * @returns
 */
export const getExportColumnOptions = async (
  contestId,
  isRegistered,
  hasResumeStage = false
) => {
  const response = await axios.get(
    `contests/${contestId}/candidates/exportable-fields-list`,
    { params: { isRegistered, hasResumeStage } }
  )
  return response
}

/**
 *
 * @param {string} contestId
 * @param {string} isRegistered
 * @returns
 */
export const getCSVExportFile = async (
  contestId,
  payload,
  isRegistered,
  hasResumeStage = false
) => {
  const response = await axios.post(
    `contests/${contestId}/candidates/export`,
    payload,
    { params: { isRegistered, hasResumeStage }, responseType: 'blob' }
  )
  return response
}

/**
 *
 * @param {string} candidateId
 * @param {string} contestId
 * @returns array
 */
export const getStagesHistory = async (
  candidateId = null,
  contestId = null
) => {
  const response = await axios.get(`/candidates/stage-history`, {
    params: { candidateId, contestId }
  })
  return response
}

/**
 *
 * @returns {Object}
 */
export const getPublicCandidateReport = async () => {
  const response = await axios.get(`/candidates/report`)
  return response
}

export const checkCandidateCodeFiles = async (attemptId) => {
  const response = await axios.get(
    `attempt-logs/check-code-files?attemptId=${attemptId}`
  )
  return response
}

/**
 * Send auxiliary device capture image to event service API
 * @param {FormData} formData - Form data containing image and metadata
 * @returns {Object} - Response with candidateStatus: 'OFFLINE/ONLINE'
 */
export const auxiliaryDeviceCapture = async (formData, token) => {
  const response = await axios.post(`${SOCKET_API_URL}aux-capture`, formData, {
    headers: {
      'content-type': 'multipart/form-data'
    },
    overrideToken: token
  })
  return response
}

export const getCandidateToken = (id) => {
  const response = axios.post('candidates/token', { id })
  return response
}

export const getAuxDeviceStatus = (id, attemptId) => {
  const response = axios.get(
    `${SOCKET_API_URL}aux-status?candidateId=${id}&attemptId=${attemptId}`
  )
  return response
}

export const rejectCandidateResume = async (payload) => {
  const response = await axios.post(`contests/reject`, payload)
  return response
}

export const getSubQuestionDetails = async (questionId) => {
  const response = await axios.get(`mcq/${questionId}`)
  return response
}

export const getCandidateCredits = async () => {
  const response = await axios.get(`candidate-practices/credits`)
  return response
}

export const getCandidateInterviews = async () => {
  const response = await axios.get(`candidate-practice-interviews/list`)
  return response
}

export const generateAIInterviewTopics = async (payload) => {
  const response = await axios.post(`candidate-practices/ai-topics`, payload)
  return response
}

export const createPracticeInterview = async (payload) => {
  const response = await axios.post(
    `candidate-practice-interviews/create`,
    payload
  )
  return response
}

export const updatePracticeInterview = async (id, payload) => {
  const response = await axios.put(
    `candidate-practice-interviews/${id}`,
    payload
  )
  return response
}

export const getPracticeInterviewAttemptId = async (
  practiceInterviewId = null
) => {
  const response = await axios.post(
    `candidate-practices/create-attempt`,
    null,
    { params: { practiceInterviewId } }
  )
  return response
}

export const candidateAddressInfo = async () => {
  const response = await axios.get(`/candidate-practices/address`)
  return response
}

export const saveCandidateBillingInfo = async (payload) => {
  const response = await axios.put(`/candidate-practices/address`, payload)
  return response
}

export const uploadCandidateAudioResponse = async (formData) => {
  const response = await axios.post(
    `candidate-answers/upload-audio-response`,
    formData
  )
  return response
}
